import { isPlatform } from "@ionic/react";
import { CA, CAN, MEX, MX, TIME_ZONE, US, USA } from "../../../utils/constants";
import { dayjs } from "../../../utils/Date/DateUtil";
import { states } from "../../../utils/states";

export const getTime = (date: string) => {
	return dayjs(date).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
}

export const stateItems = [
	{
		label: 'State 1',
		name: 'state1',
		value: ''
	},
	{
		label: 'State 2',
		name: 'state2',
		value: ''
	},
	{
		label: 'State 3',
		name: 'state3',
		value: ''
	}
]

export const setDetails = (details: any, callback: Function) => {
  const { country, postalCode, lat, lng, value: address } = details;
  const [city, state] = address ? address.split(", ") : ["", ""];
  return callback({
    city,
    state,
    country,
    postal: postalCode,
    lat,
    lng,
    address
  });
};

export const keyboardshowHandler = () => {
	const headerDiv = document.getElementsByClassName(
		"add-capacity-grid-mobile"
	)[0];
	isPlatform("mobile") && headerDiv.classList.add("scroll-up");
};

export const keyboardhideHandler = () => {
	const headerDiv = document.getElementsByClassName(
		"add-capacity-grid-mobile"
	)[0];
	isPlatform("mobile") && headerDiv.classList.remove("scroll-up");
};

export const formatStatesList = (items: any) => {
	return items?.map((value: any) => {
		const state = states.find((state: any) => state.code === value);
		return (state && state.name) || value;
	});
}

export const getCountryCode = (code: any) => {
	switch (code) {
		case US:
			return USA;
		case CA:
			return CAN;
		case MX:
			return MEX;
		default:
			return code;
	}
}
